<template>
  <div class="flight-pad-horizontal-path">
    <!-- duration -->
    <flight-pad-duration
      v-if="itinerary.duration"
      :duration="itinerary.duration"
      full
    />
    <div class="flight-pad-horizontal-path__visual">
      <!-- start -->
      <vb-icon :name="'flight_start'" :size="20" :color="sass('primary')" class="flight-dot flight-dot--start">
      </vb-icon>
      <div class="flex-grow-1 w-100 d-flex align-items-center">
        <div class="flight-pad-horizontal-path__visual__line" />
      </div>
      <!-- middle (optional) -->
      <vb-icon
        v-if="itinerary.segments.length > 1"
        :name="'flight_stop'"
        :size="20"
        :color="sass('primary')"
        class="flight-dot flight-dot--mid"
      >
      </vb-icon>
      <div
        v-if="itinerary.segments.length > 1"
        class="flex-grow-1 w-100 d-flex align-items-center"
      >
        <div class="flight-pad-horizontal-path__visual__line"></div>
      </div>
      <!-- end -->
      <vb-icon :name="'plane'" :size="20" :color="sass('primary')"> </vb-icon>
    </div>
    <flight-pad-stops :itinerary="itinerary" color="primary" />
  </div>
</template>

<script> 
import FlightPadDuration from "@liveflight/components/blocks/flight-pad/flight-pad-duration.vue";
import FlightPadStops from "@liveflight/components/blocks/flight-pad/flight-pad-stops.vue";

export default {
  name: "flight-pad-horizontal-path",
  components: {
    "flight-pad-duration": FlightPadDuration,
    "flight-pad-stops": FlightPadStops,
  },
  props: {
    itinerary: Object,
  }, 
};
</script>

<style lang="scss" scoped>
.flight-pad-horizontal-path {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__visual {
    width: 100%;
    display: flex;
    padding-left: 10px;
    padding-right: 10px;
    gap: 5px;

    &__line {
      min-width: 100%;
      height: 1px;
      min-height: 1px;
      max-height: 1px;
      border: 1px solid var(--primary);
      border-radius: 50px;
    }
  }

  @include media-breakpoint-down(md) {
    &__duration {
      display: none;
    }
  }

  .flight-dot {
    position: relative;

    &--start,
    &--mid {
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid $gray-600;
        border-radius: 50%;
      }
    }

    &--start:after {
      width: calc(100% - 3px);
      height: calc(100% - 3px);
    }

    &--mid:after {
      width: calc(100% - 5px);
      height: calc(100% - 5px);
    }
  }
}
</style>
